import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'

import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import SettingContext from '@/product/context/setting/settingContext'
import { Button } from '@mui/material'
import ReviewManage from './ReviewManage'
import CustomDialog from '@/product/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'

const Payment = (props) => {
    const alertContext = useContext(AlertContext)
    const settingContext = useContext(SettingContext)
    const history = useHistory()
    const { setAlert } = alertContext
    const {
        all_reviews,
        getAllReviews,
        reviewAction,
        responseStatus: responseStatusAuction,
        clearResponse: clearResponseAuction,
    } = settingContext
    const [selectedReview, setSelectedReview] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    let action = props.match.params.action

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            action: action,
            searchterm: '',
            fielddate: 'date_closed',
            fromdate: '',
            todate: '',
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                title: {
                    value: '',
                    type: 'like',
                    field: 'ur.title',
                },
                description: {
                    value: '',
                    type: 'like',
                    field: 'ur.description',
                },
                to_username: {
                    value: '',
                    type: 'like',
                    field: 'e.username',
                },
                from_username: {
                    value: '',
                    type: 'like',
                    field: 'u.username',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllReviews(values)
        },
    })

    useEffect(() => {
        if (all_reviews) {
            setTableBody(all_reviews.records.length ? all_reviews.records : [])

            setIsLoading(false)
        }
    }, [all_reviews])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.action = action
        formik.values.page = 1

        formik.values.filters.title.value = ''
        formik.values.filters.description.value = ''
        formik.values.filters.to_username.value = ''
        formik.values.filters.from_username.value = ''

        getAllReviews(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [])

    const onClickEdit = (id, secondaryId, type) => {
        if (type === 'viewReview') {
            const review = tableBody.filter((cat) => cat.id === id)

            if (review.length) {
                setSelectedReview(review[0])
            }

            toggleFullScreenPopup(true, 'edit', id)
        } else if (type === 'deleteReview') {
            formikSelection.values.action = 'removed'
            formikSelection.values.review_id = id

            setChangeStatus(true)
        }
    }

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            review_id: '',
        },
        onSubmit: (values) => {
            if (values.action === 'removed') {
                setIsLoading(true)
                reviewAction(values)
            }
        },
    })

    const [changeStatus, setChangeStatus] = React.useState(false)

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.review_id = data
        if (action === 'removed') {
            setChangeStatus(true)
        }
    }

    const getMultipleAction = () => {
        let actionPush = []

        actionPush.push({
            buttonType: 'visibility',
            clickType: 'viewReview',
            onclick: onClickEdit,
            tooltipTitle: 'View Review',
        })
        actionPush.push({
            buttonType: 'delete',
            clickType: 'deleteReview',
            onclick: onClickEdit,
            tooltipTitle: 'Delete Review',
        })

        return actionPush
    }

    const tableValues = [
        // {
        //     field: 'users_first_name',
        //     type: '',
        //     firstChild: true,
        //     sort: false,
        //     disablePadding: false,
        //     label: 'From - First Name',
        // },
        // {
        //     field: 'users_last_name',
        //     type: '',
        //     firstChild: true,
        //     sort: false,
        //     disablePadding: false,
        //     label: 'From - Last Name',
        // },
        {
            field: 'users_username',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'From',
        },
        // {
        //     field: 'as_employees_emp_firstname',
        //     type: '',
        //     firstChild: false,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'To - First Name',
        // },
        // {
        //     field: 'as_employees_emp_lastname',
        //     type: '',
        //     sort: true,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'To - Last Name',
        // },
        {
            field: 'as_employees_username',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'To',
        },
        {
            field: 'rating',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Rating',
        },
        {
            field: 'created_at',
            type: 'datetime',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Date',
        },
        {
            name: 'action',
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
            tableShow: 1,
        },
    ]

    const tableActions = [
        {
            label: 'Delete',
            icon: <span className="material-icons">delete</span>,
            onclick: onSelectMultiProducts,
            type: 'removed',
        },
    ]

    const searchInfo = [
        {
            label: 'To',
            placeholder: 'Enter To User Name',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'to_username',
            formik: formik,
            filter: true,
        },
        {
            label: 'From',
            placeholder: 'Enter title',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'from_username',
            formik: formik,
            filter: true,
        },
        {
            label: 'Title',
            placeholder: 'Enter title',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'title',
            formik: formik,
            filter: true,
        },
        {
            label: 'Description',
            placeholder: 'Enter Description',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'description',
            formik: formik,
            filter: true,
        },
    ]

    useEffect(() => {
        if (responseStatusAuction) {
            if (
                responseStatusAuction.status === 'success' &&
                responseStatusAuction.from === 'reviewAction'
            ) {
                toggleFullScreenPopup(false)
                setChangeStatus(false)
                setIsLoading(true)
                getAllReviews(formik.values)
            }
        }
    }, [responseStatusAuction])

    const formikPagniationHandle = (formik) => {
        setIsLoading(true)
        getAllReviews(formik, 'reviewAction')
    }

    return (
        <Layout>
            <div className="dashboard auctionLots">
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                {/* {isLoading && <div>loading......</div>} */}
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    isLoading={isLoading}
                    allData={all_reviews}
                    changeTableFunction={formikPagniationHandle}
                />
            </div>

            <CustomDialog
                title={'Feedback'}
                open={manage.popup}
                function={() => toggleFullScreenPopup(false)}
            >
                <h5>
                    Seller Name: {selectedReview?.as_employees_emp_firstname}{' '}
                    {selectedReview?.as_employees_emp_lastname} (
                    {selectedReview?.as_employees_username})
                </h5>
                <h5>Title: {selectedReview?.title}</h5>
                <h5>
                    Average Review Point:{' '}
                    {(
                        (selectedReview?.communication +
                            selectedReview?.speed_of_transaction +
                            selectedReview?.item_as_described +
                            selectedReview?.satisfaction +
                            selectedReview?.rating) /
                        5
                    ).toFixed(1)}
                    /5
                </h5>
                <h5>Communication : {selectedReview?.communication}/5</h5>
                <h5>
                    Speed of transaction :{' '}
                    {selectedReview?.speed_of_transaction}/5
                </h5>
                <h5>
                    Item as described : {selectedReview?.item_as_described}/5
                </h5>
                <h5>Satisfaction : {selectedReview?.satisfaction}/5</h5>
                <h5>Overall Rating: {selectedReview?.rating}/5</h5>

                <h5>Description: {selectedReview?.description}</h5>

                <div className="actionWrapper">
                    <Button
                        id="payment_cancel"
                        onClick={() => toggleFullScreenPopup(false)}
                    >
                        Close
                    </Button>
                </div>
            </CustomDialog>

            <CustomDialog
                title={'Change review status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to remove the review</h5>
                <div className="actionWrapper">
                    <Button
                        id="payment_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="payment_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}

export default Payment
